import {
  DisclosureChecklistId,
  DisclosureChecklistLineId,
  DisclosurePageRef,
  EngagementId,
  TprmQuestionTemplateId,
} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const disclosureSummary = typedQuery(
  ["tprm", "disclosureSummary", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.summary(engagementId);
  },
);

export const disclosurePageActivityStream = typedQuery(
  ["tprm", "disclosurePageActivityStream", param<EngagementId>("engagementId"), param<DisclosurePageRef>("page")],
  async (engagementId, page) => {
    return await api.tprm.disclosures.openPageActivityStream(engagementId, page);
  },
);

export const disclosureTailoring = typedQuery(
  ["tprm", "disclosureTailoring", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.getTailoring(engagementId);
  },
);

export const disclosureTailoringHistory = typedQuery(
  [
    "tprm",
    "disclosureTailoringHistory",
    param<EngagementId>("engagementId"),
    param<TprmQuestionTemplateId>("questionTemplateId"),
  ],
  async (engagementId, questionTemplateId) => {
    return await api.tprm.disclosures.getTailoringHistory(engagementId, questionTemplateId);
  },
);

export const disclosureDocuments = typedQuery(
  ["tprm", "disclosureDocuments", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.documents(engagementId);
  },
);

export const disclosureChecklists = typedQuery(
  ["tprm", "disclosureChecklists", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosureChecklists.list(engagementId);
  },
);

export const disclosureChecklist = typedQuery(
  ["tprm", "disclosureChecklist", param<DisclosureChecklistId>("checklistId")],
  async checklistId => {
    return await api.tprm.disclosureChecklists.get(checklistId);
  },
);

export const disclosureChecklistLineHistory = typedQuery(
  [
    "tprm",
    "disclosureChecklistLineHistory",
    param<DisclosureChecklistId>("checklistId"),
    param<DisclosureChecklistLineId>("lineId"),
  ],
  async (checklistId, lineId) => {
    return await api.tprm.disclosureChecklists.lineHistory(checklistId, lineId);
  },
);
